import React from "react";

import { BlueprintIcon, BlueprintIconProps } from "../blueprint-icon";

export const Assist: React.FC<BlueprintIconProps> = (props) => (
  <BlueprintIcon viewBox="0 0 24 24" {...props}>
    <path d="M17.5 3L18.1752 4.82477L20 5.5L18.1752 6.17523L17.5 8L16.8248 6.17523L15 5.5L16.8248 4.82477L17.5 3Z"/>
    <path d="M17.5 16L18.1752 17.8248L20 18.5L18.1752 19.1752L17.5 21L16.8248 19.1752L15 18.5L16.8248 17.8248L17.5 16Z"/>
    <path d="M10 6L11.6205 10.3795L16 12L11.6205 13.6205L10 18L8.37946 13.6205L4 12L8.37946 10.3795L10 6Z"/>
  </BlueprintIcon>
);